/** Lecturas locales/remotas usadas por pantallas de informes (no exportar en public-api). */

export { getCashSummary } from '../../cash/domain-api';
export type { CashSummary } from '../../cash/domain-api';

export {
  getTodaySalesSnapshot,
  getSalesSnapshotByDateRangeWithVentasScope,
  getSalesSnapshotByDateRange,
  getPromotionPerformanceByDateRange,
  getPaymentMethods,
  getSalesByTimeBand,
  getSalesComparison,
} from '../../sales/public-api';
export type {
  PaymentMethodRow,
  PromotionPerformanceSnapshot,
  SalesByCashierRow,
  SalesByTimeBandRow,
  SalesComparison,
  SalesSnapshot,
} from '../../sales/public-api';

export { getInventoryDashboard } from '../../inventory/public-api';
export { getCustomerDaySummary } from '../../customers/public-api';
export type { CustomerDaySummary } from '../../customers/public-api';

export { getIntelligenceKpis } from '../infra/intelligenceKpisRepo';
export type {
  IntelligenceKpisPreset,
  IntelligenceKpisResponse,
  RentabilidadDailyRow,
  TurnoKpiHistoryRow,
} from '../domain/reportsIntelligenceTypes';

export {
  getExternalServiceOperations,
  getExternalServiceOperationsSummary,
  insertExternalServiceOperation,
} from '../../shell/externalServiceRepo';
export type { ExternalServiceOperationRow, ExternalServiceOperationsSummary } from '../../shell/externalServiceRepo';

export {
  listCategories,
} from '../../catalog/public-api';
export {
  listDistinctProductBrandsLocal,
} from '../../catalog/public-api';
export {
  listActiveSuppliersLocal,
} from '../../catalog/public-api';
export {
  syncCatalogSnapshotFromRemote,
} from '../../catalog/public-api';
